import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../Buttons';

const StyledSection = styled.div`
  margin: 15px;
  background-color: #f5f5f5;
  /* padding: 140px 90px 0 90px; */

  @media (max-width: 566px) {
    margin: 0;
  }
`;

const MothershipTitle = styled.h1`
  height: 60px;
  width: max-content;
  max-width: 100%;
  color: #1d1d1d;
  font-family: AvenirBold;
  font-size: 44px;
  font-weight: 900;
  letter-spacing: -0.15px;
  line-height: 60px;

  @media (max-width: 991px) {
    font-size: 36px;
  }

  @media (max-width: 566px) {
    font-size: 28px;
    line-height: 36px;
  }
`;

const StyledColumnTitle = styled.h2`
  // width: 384px;
  white-space: nowrap;
  color: #040404;
  font-family: AvenirMedium;
  font-size: 30px;
  letter-spacing: -0.16px;

  @media (max-width: 991px) {
    letter-spacing: -0.1px;
    font-size: 20px;
    /* width: 225px; */
  }
`;

const StyledColumnText = styled.h2`
  height: 72px;
  width: 384px;
  color: #8d848d;
  font-family: Avenir;
  font-size: 18px;
  letter-spacing: 0.15px;
  line-height: 36px;

  @media (max-width: 991px) {
    height: 48px;
    width: 269px;
    font-size: 16px;
    letter-spacing: 0.12px;
    line-height: 24px;
  }
`;

const StyledLineRow = styled.div`
  height: 1px;
  display: none;
  flex-direction: row;
  width: 100%;
  @media (max-width: 767px) {
    display: flex;
  }
`;

const StyledYellowLineRow = styled.div`
  border: 1px solid #febb39;
  width: 76px;
`;

const StyledGreyLineRow = styled.div`
  background-color: #e2dfe2;
  flex-grow: 1;
  border: 1px solid #e2dfe2;
`;

const StyledLineColumn = styled.div`
  width: 1px;
  display: flex;
  flex-direction: column;
  height: 414px;

  @media (max-width: 767px) {
    display: none;
  }
`;

const StyledYellowLineColumn = styled.div`
  border: 1px solid #febb39;
  height: 76px;
`;

const StyledGreyLineColumn = styled.div`
  background-color: #e2dfe2;
  flex-grow: 1;
  border: 1px solid #e2dfe2;
`;

const SpacerDiv = styled.div`
  height: 70px;

  @media (max-width: 566px) {
    height: 40px;
  }
`;

const SmallSpacerDiv = styled.div`
  height: 30px;

  @media (max-width: 566px) {
    height: 30px;
  }
`;

const Mothership = () => (
  <StyledSection>
    <div className='container d-flex flex-column'>
      <SpacerDiv />
      <MothershipTitle>Contact the mothership</MothershipTitle>
      <SpacerDiv />
      <div className='row'>
        <div className='col col-12 col-md-5  d-flex flex-column justify-content-around'>
          <div>
            <StyledColumnTitle>Want to work together?</StyledColumnTitle>
            <StyledColumnText>Do you have a project for us? Let’s talk about it.</StyledColumnText>
          </div>
          <PrimaryButton text='Contact Us' to='/contact' />
          <SpacerDiv className='d-none d-sm-block' />
        </div>
        <div className='col col-md-2 col-12 px-0'>
          <StyledLineColumn className='mx-auto'>
            <StyledYellowLineColumn />
            <StyledGreyLineColumn />
          </StyledLineColumn>
          <StyledLineRow className='my-4 py-4'>
            <StyledYellowLineRow />
            <StyledGreyLineRow />
          </StyledLineRow>
        </div>
        <div className='col col-12 col-md-5 d-flex flex-column justify-content-around '>
          <div>
            <StyledColumnTitle>Join our station!</StyledColumnTitle>
            <StyledColumnText>
              Would you like to join our team and work on some great explorations
            </StyledColumnText>
          </div>
          <a
            href='https://sites.google.com/a/werplay.com/careers/'
            target='_blank'
            style={{ textDecoration: 'none' }}>
            <PrimaryButton text='See Careers' />
          </a>
          <SpacerDiv />
        </div>
      </div>
    </div>
  </StyledSection>
);

export { Mothership };
